import { createSlice } from '@reduxjs/toolkit';

const saved = (() => {
  try {
    const u = localStorage.getItem('user');
    const t = localStorage.getItem('token');
    return u && t ? { user: JSON.parse(u), token: t, isAuthenticated: true } : null;
  } catch { return null; }
})();

const authSlice = createSlice({
  name: 'auth',
  initialState: saved || { user: null, token: null, isAuthenticated: false },
  reducers: {
    login(state, { payload }) {
      state.user = payload.user;
      state.token = payload.token;
      state.isAuthenticated = true;
      localStorage.setItem('user', JSON.stringify(payload.user));
      localStorage.setItem('token', payload.token);
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    },
    updateUser(state, { payload }) {
      state.user = { ...state.user, ...payload };
      localStorage.setItem('user', JSON.stringify(state.user));
    },
  },
});

export const { login, logout, updateUser } = authSlice.actions;
export default authSlice.reducer;
